<template>
    <div>
        <CCol sm="12">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <img src="../assets/img/calendar-black.png" style="max-width:25px" />
                <span class="custom-18px-500 text-left font-color-171717 ml-2 mt-2">{{ formattedDate }}</span>
                <CCard class="custom-border-radius-16px custom-info-blue text-left mt-2 mb-0" style="border:none;text-align:left">
                    <CRow>
                        <CCol sm="12" md="4" lg="3" class="text-left p-2" v-for="button in buttons" :key="button.value">
                            <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                                <img :src="activeButton === button.value ? require(`@/assets/img/${button.activeIcon}`) : require(`@/assets/img/${button.inactiveIcon}`)" style="max-width:20px" class="mr-2" /> {{ button.label }}
                            </div>
                        </CCol>
                        <CCol sm="12" md="4" lg="3" class="text-right p-2">
                            <CButton class="btn-border-blue font-color-0B63F6" @click="openAttendance()"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1"/>Create Attendance</CButton>
                        </CCol>
                        <CCol sm="12" v-if="activeButton === 'TodayAttendance'">
                            <CRow class="p-0">
                            <CCol sm="3" class="p-1">
                                <div class="custom-bg-gradient-red" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Total Staff
                                    </h3>
                                    <p class="custom-32px-700 text-white">{{ countStaff }}</p>
                                </div>
                            </CCol>
                            <CCol sm="3" class="p-1">
                                <div class="custom-bg-gradient-blue-white" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Total Clock In
                                    </h3>
                                    <p class="custom-32px-700 text-white">{{ countTodayAtt }}</p>
                                </div>
                            </CCol>
                            <CCol sm="3" class="p-1">
                                <div class="custom-bg-gradient-white-blue" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Total Absent
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="3" class="p-1">
                                <div class="custom-bg-gradient-purple" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        On Leave
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
    
                        </CRow>
                        </CCol>
    
                        <CCol sm="12" v-if="activeButton === 'AttendanceReport'">
                            <CRow>
                                <CCol sm="3">
                                    <label class="custom-14px-500 font-color-171717">Date Period</label>
                                    <CInput type="text" />
                                </CCol>
                                <CCol sm="3">
                                    <label class="custom-14px-500 font-color-171717">Department</label>
                                    <CSelect/>
                                </CCol>
                                <CCol sm="3">
                                    <label class="custom-14px-500 font-color-171717">Employee</label>
                                    <CSelect/>
                                </CCol>
                                <CCol sm="3">
                                    <label class="custom-14px-500 font-color-171717">Shift</label>
                                    <CSelect/>
                                </CCol>
                            </CRow>
                        </CCol>
    
                        <CCol sm="12" v-if="activeButton === 'AttendanceSummary'">
                            <CRow>
                                <CCol sm="4">
                                    <label class="custom-14px-500 font-color-171717">Date Period</label>
                                    <CInput type="text" />
                                </CCol>
                                <CCol sm="4">
                                    <label class="custom-14px-500 font-color-171717">Department</label>
                                    <CSelect/>
                                </CCol>
                                <CCol sm="4">
                                    <label class="custom-14px-500 font-color-171717">Employee</label>
                                    <CSelect/>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
    
                </CCard>
    
    
                <CCard class="p-3 custom-border-radius-16px mt-2" style="border:none">
                    <div v-if="activeButton === 'TodayAttendance'">
    
                        <CCol sm="12" md="4" lg="3" style="float:left">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="d-flex font-color-171717">
                                        <label class="m-2">Show </label><select v-model="perPage" id="entries" class="form-control">
                                            <option :value="10">10</option>
                                            <option :value="25">25</option>
                                            <option :value="50">50</option>
                                            <option :value="100">100</option>
                                        </select> <label class="m-2">entries </label>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="mb-2">
                                        <CInput type="text" placeholder="Search...." v-model.lazy="SearchQuery" @change="applyFilter()" />
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <br /><br /><br />
                        <CCol sm="12">
    
    
                            <table class="table table-responsive-sm" v-if="Array.isArray(filteredattendanceTableData) && filteredattendanceTableData.length > 0">
                                <thead class="custom-table">
                                    <th>No</th>
                                    <th>Requestor</th>
                                    <th>Clock In</th>
                                    <th>Clock Out</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in filteredattendanceTableData" :key="item.id">
                                        <td>
                                            <label class="custom-14px-500 font-color-98A2B3">{{ (currentPage - 1) * pageSize + index + 1 }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.FullName }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">
              {{ item.ClockIn }}
            </label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.ClockOut }}</label>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openDetailAttendance(item.Id)" class="ml-2" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
    
                            <div v-else class="no-data-message">
    
                                <div class="full-height-container">
                                    <div class="no-data-message">
                                        <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
                                        <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                        <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </div>
    
                    <div v-if="activeButton === 'AttendanceReport'">
                        <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="2" md="2" lg="2"> <img style="max-width:30px" src="../assets/img/printer_square.png" class="mt-4" /></CCol>
                                    <CCol sm="10">
                                        <span>Per entries</span>
                                        <select v-model="perPage" id="entries" class="form-control">
                                                                            <option :value="10">10</option>
                                                                            <option :value="25">25</option>
                                                                            <option :value="50">50</option>
                                                                            <option :value="100">100</option>
                                                                        </select>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
    
                        <v-client-table :data="attendanceTableData" :columns="columns" :options="options" class="custom-table" v-if="attendanceTableData.length > 0">
                            <template v-slot:No="{ row }">
            <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Name="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.Name }}</label>
</template>

<template v-slot:Clock In="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.ClockIn }}</label>
</template>

<template v-slot:Clock Out="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.ClockOut }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex">
        <img :src="require('@/assets/img/eye.png')" alt="Print" style="cursor: pointer;width:20px" @click="printRow(row.Index)" />
        <img :src="require('@/assets/img/trash.png')" alt="View" style="cursor: pointer;width:20px" @click="viewRow(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/edit-linear.png')" alt="View" style="cursor: pointer;width:20px" @click="viewRow(row.Index)" class="ml-2" />
    </div>
</template>
                                        </v-client-table>
                                        <div v-else class="no-data-message text-center" style="margin:10%">
                                <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                                <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                </div>
                        </div>

                        <div v-if="activeButton === 'AttendanceSummary'">
                        <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="2" md="2" lg="2"> <img style="max-width:30px" src="../assets/img/printer_square.png" class="mt-4" /></CCol>
                                    <CCol sm="10">
                                        <span>Per entries</span>
                                        <select v-model="perPage" id="entries" class="form-control">
                                                                    <option :value="10">10</option>
                                                                    <option :value="25">25</option>
                                                                    <option :value="50">50</option>
                                                                    <option :value="100">100</option>
                                                                </select>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
    
                        <v-client-table :data="summaryTableData" :columns="columnsSummary" :options="options" class="custom-table" v-if="summaryTableData.length > 0">
<template v-slot:No="{ row }">
    <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Name="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.Name }}</label>
</template>

<template v-slot:Present="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.Present }}</label>
</template>

<template v-slot:Absent="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.Absent }}</label>
</template>

<template v-slot:Late="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.Late }}</label>
</template>

<template v-slot:Early Clock Out="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.EarlyClockOut }}</label>
</template>


<template v-slot:Action="{ row }">
    <div class="d-flex">
        <img :src="require('@/assets/img/eye.png')" alt="Print" style="cursor: pointer;width:20px" @click="printRow(row.Index)" />
        <img :src="require('@/assets/img/trash.png')" alt="View" style="cursor: pointer;width:20px" @click="viewRow(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/edit-linear.png')" alt="View" style="cursor: pointer;width:20px" @click="viewRow(row.Index)" class="ml-2" />
    </div>
</template>
                                        </v-client-table>
                                        <div v-else class="no-data-message text-center" style="margin:10%">
                                <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                                <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                </div>
                        </div>
                    </CCard>
                                
    
            </CCol>
    
        </CCol>

        <div v-if="OpenAddAttendance" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Create Attendance Record</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddAttendance" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Employee Name</h3>
                                        <CInput type="text" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Shift</h3>
                                        <CInput type="text"/>
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-16px-700 font-color-171717 text-left">Clock In Information</h3>
                                        <h3 class="custom-14px-500 font-color-171717">Clock In Time</h3>
                                        <CInput type="text"/>

                                        <h3 class="custom-14px-500 font-color-171717">Clock In Note</h3>
                                        <CTextarea rows="4"/>
                                        
                                        <CRow>
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Clock In Indicator<span class="custom-12px-500 font-color-98A2B3"> (Set as late in)</span></h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                            </CCol>
                                        </CRow>
                                    </CCol>

                                    <CCol sm="12">
                                        <h3 class="custom-16px-700 font-color-171717 text-left mt-3">Clock Out Information</h3>
                                        <h3 class="custom-14px-500 font-color-171717">Clock Out Time</h3>
                                        <CInput type="text"/>

                                        <h3 class="custom-14px-500 font-color-171717">Clock Out Note</h3>
                                        <CTextarea rows="4"/>
                                        
                                        <CRow>
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Clock Out Indicator<span class="custom-12px-500 font-color-98A2B3"> (Set as early out)</span></h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                   
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                        <CCol sm="6"> <CButton class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="closePopupAddAttendance" block>Cancel</CButton></CCol>
                        <CCol sm="6">
                            <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white border-half" block>Submit</CButton>
                        </CCol>
                        </CRow>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            activeButton: 'TodayAttendance', // Default active button
            buttons: [
                { value: 'TodayAttendance', label: 'Today Attendance', activeIcon: 'checked-white.png', inactiveIcon: 'checked-blue.png' },
                { value: 'AttendanceReport', label: 'Attendance Report', activeIcon: 'clocked-white.png', inactiveIcon: 'clock-blue.png' },
                { value: 'AttendanceSummary', label: 'Attendance Summary', activeIcon: 'summary-white.png', inactiveIcon: 'summary-blue.png' },
            ],
            columns: [
                'No',
                'Name',
                'Clock In',
                'Clock Out',
                'Action'
            ],
            attendanceTableData: [
                { No: 1, Name: 'Asyikin', 'Clock In': '08:05 AM', 'Clock Out': '17:30 PM' },
                { No: 2, Name: 'Amirah', 'Clock In': '08:15 AM', 'Clock Out': '17:45 PM' },
                { No: 3, Name: 'Syakira', 'Clock In': '08:25 AM', 'Clock Out': '17:55 PM' }
            ],
            columnsSummary: [
                'No',
                'Name',
                'Present',
                'Absent',
                'Late',
                'Early Clock Out',
                'Action'
            ],
            summaryTableData: [
                { No: 1, Name: 'Asyikin', 'Present': '14', 'Absent': '2', 'Late': '0', 'Early Clock Out': 0 },
                { No: 2, Name: 'Amirah', 'Present': '20', 'Absent': '0', 'Late': '0', 'Early Clock Out': 0 },
                { No: 3, Name: 'Syakira', 'Present': '10', 'Absent': '5', 'Late': '0', 'Early Clock Out': 0 }
            ],
            filteredattendanceTableData: [],
            attendanceData: [],
            SearchQuery: "",
            perPage: "",
            currentPage: 1,
            pageSize: 5,
            totalPages: 10,
            hasNextPage: "",

            countStaff: {},
            countTodayAtt: {},

            OpenAddAttendance: false

        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                this.GetInfoUser();
                this.GetListAttendance();
                this.GetTotalStaff();
                this.GetTotalStaffClockIn();

            } else {
                this.GoToPage();


            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {
        formattedDate() {
            const now = new Date();
            const day = now.getDate();
            const month = now.toLocaleString('en-US', { month: 'long' });
            const year = now.getFullYear();

            return `${day} ${month} ${year}`;
        }

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },

        GetListAttendance() {
            console.log('Calling API with SearchQuery:', this.SearchQuery);
            this.Busy = true;
            let url = `read/GetTodayListAttendanceByHr?page=${this.currentPage}&limit=${this.pageSize}&keyword=${this.SearchQuery}`;

            console.log('Complete URL:', url);

            return this.$API
                .get(url, { withCredentials: true })
                .then((response) => {
                    this.Busy = false;
                    if (response.status === 200) {

                        this.attendanceData = response.data;
                        this.filteredattendanceTableData = this.attendanceData;

                        this.hasNextPage = this.currentPage < this.totalPages; // Enable or disable next button

                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    console.error('Error fetching data:', error);

                    this.hasNextPage = false; // Disable next button in case of error
                });
        },
        async GetTotalStaff() {
            try {
                const response = await this.$API.get(this.$GetCountStaff, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.countStaff = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetTotalStaffClockIn() {
            try {
                const response = await this.$API.get(this.$GetCountTodayListAttendanceByHrClockIn, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.countTodayAtt = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        openAttendance()
        {
            this.OpenAddAttendance = true;
        },
        closePopupAddAttendance()
        {
            this.OpenAddAttendance = false;
        }


    }

};
</script>